<template>
	<div class="addinfo">
		<el-row :gutter="20">
			<el-col :span="14">
				<div class="list">
					<div>
						<div class="listSum titlebg">附加链接</div>
						<div class="srcolldiv">
							<div class="itemDiv link" v-for="(item, index) in webpageList" :key="index">
								<div @click="open(item)">
									{{ item.showText }}
								</div>
							</div>
						</div>
						<div class="listSum titlebg">附加宣传信息</div>
						<div class="srcolldiv">
							<div class="itemDiv" v-for="(item, index) in propagandaList" :key="index">
								{{ item.content }}
							</div>
						</div>
						<div class="listSum titlebg">附加结构化信息</div>
						<div class="srcolldiv">
							<div class="itemDiv" v-for="(item, index) in structureList" :key="index">
								{{ item.content }}
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div>
					<preview
						v-bind="prdItemData"
						:adTitleList="adTitleList"
						:domain="'https://'+queryParam.name"
					></preview>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import preview from './prd-preview';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: ['propagandaList', 'structureList', 'webpageList'],
	data() {
		return { activeItem: 0, adTitleList: [], automationContentId: '' };
	},

	components: { preview },

	computed: {
		queryParam() {
			return this.$route.query;
		},
		automationId() {
			return this.$route.query.id;
		},
		prdItemData() {
			return {
				adExplainList: this.propagandaList,
				propagandalist: this.structureList,
				webpageList: this.webpageList,
			};
		},
	},
	methods: {
		async getproduct() {
			let res = await adsNewOnlineSer.getproduct({
				id: this.automationId,
			});
			let pomotionArr = res.data.productList.concat(res.data.productTypeList);
			this.automationContentId = pomotionArr[0].automationContentId;
		},
		getAdTitleList() {
			this.getproduct().then(async () => {
				let res = await adsNewOnlineSer.productdetail({
					automationContentId: this.automationContentId,
					automationId: this.automationId,
				});
				this.adTitleList = res.data.adTitleList;
			});
		},
		open(item) {
			let pagePath = item.pagePath;
			window.open(pagePath);
		},
	},
	created() {
		this.getAdTitleList();
	},
};
</script>

<style lang="scss" scoped>
.addinfo {
	padding: 20px 30px 50px 20px;
}
.titlebg {
	background: #fafafa;
	height: 54px;
	line-height: 54px;
}
.bg {
	background: #ebf5ff;
}
.listSum {
	text-align: left;
	padding-left: 20px;
	border-bottom: 1px #e8e8e8 solid;
}
.link {
	cursor: pointer;
	color: #3da1ff;
}
.itemDiv {
	width: 33.3%;
	padding: 0px 20px;
	text-align: left;
	line-height: 54px;
	align-items: center;
	border-bottom: 1px #e8e8e8 solid;
}
.srcolldiv {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 30px;
	border-bottom: 1px #e8e8e8 solid;
}
/*滚动条样式*/
.srcolldiv::-webkit-scrollbar {
	position: relative;
	width: 6px;
}
.srcolldiv::-webkit-scrollbar-thumb {
	border-radius: 10px;
	// box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
	background: rgba(163, 155, 155, 0.2);
}
.srcolldiv::-webkit-scrollbar-track {
	// box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
	border-radius: 0;
	// background: rgba(193, 185, 185, 0.1);
}
</style>
